<template>
  <div>
    <div
        class="border-0 px-0 py-0 d-inline-flex w-100"
    >
      <div
          class="px-5 py-2 cursor-pointer w-100 text-center border rounded-ts-lg rounded-bs-lg"
          @click="onTabChange(false)"
          :class="!isVehicleInLeasing ? 'bg-primary' : 'bg-surface text-grey'"
      >
        {{ translation(translationList.no, 'Nu') }}
      </div>
      <div
          class="px-5 py-2 cursor-pointer w-100 text-center border rounded-te-lg rounded-be-lg"
          @click="onTabChange(true)"
          :class="isVehicleInLeasing ? 'bg-primary' : 'bg-surface text-grey'"
      >
        {{ translation(translationList.yes, 'Da') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import {translation, useTranslationStore} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  name: 'RcaIsVehicleInLeasingTab',
  props: {
    modelValue: {
      type: [Boolean, null],
      default: false,
    },
  },
  setup(props, { emit }) {
    const isVehicleInLeasing = ref(props.modelValue);
    const translationList = ref<TranslationList>({});

    const translationStore = useTranslationStore();

    const onTabChange = (newValue: boolean) => {
      isVehicleInLeasing.value = newValue;
      emit('update:modelValue', newValue);
      emit('validation-vehicle-status', { field: 'is_vehicle_in_leasing', isValid: true });
    };

    watch(() => props.modelValue, (newValue) => {
      isVehicleInLeasing.value = newValue;
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = isVehicleInLeasing.value !== null;
      emit('validation-vehicle-status', { field: 'is_vehicle_in_leasing', isValid });

      // Listen for validate event
      window.addEventListener('validate-vehicle', (data) => {
        if (data.detail && data.detail === 'is_vehicle_in_leasing') {
          const isValid = isVehicleInLeasing.value !== null;
          emit('validation-vehicle-status', { field: 'is_vehicle_in_leasing', isValid });
        }
      });
    });

    return {
      isVehicleInLeasing,
      onTabChange,
      translationList,
      translation,
    };
  },
});
</script>

<style scoped>

</style>
